import { getLinks as _getLinks } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
type RequiresPageParam = { requiresPage?: boolean }

export function getStaticPathsForPage() {
  return async () => ({
    paths: [{ params: { page: '2' } }],
    fallback: 'blocking',
  })
}

const getLinks = traceFunction('getLinks', _getLinks)

export function getStaticPathForMakes({
  requiresPage = false,
}: RequiresPageParam) {
  return async () => {
    const makes = (await getTopMakes()).slice(0, 10)

    const paths = makes.map(({ make }) => ({
      params: { make, page: requiresPage ? '2' : undefined },
    }))

    return {
      paths,
      fallback: 'blocking',
    }
  }
}

export function getStaticPathForModels({
  requiresPage = false,
}: RequiresPageParam) {
  return async () => {
    const makes = (await getTopMakes()).slice(0, 10)
    const models = (
      await Promise.all(makes.map(({ make }) => getTopModelForMake(make)))
    ).flat()

    const paths = models.map(({ make, model }) => ({
      params: {
        make,
        model,
        page: requiresPage ? '2' : undefined,
      },
    }))

    return {
      paths,
      fallback: 'blocking',
    }
  }
}

async function getTopMakes() {
  const links = await getLinks('car-reviews-v2/')

  const makes = Object.values(links).reduce<string[]>((acc, link) => {
    if (link.is_folder && link.slug !== 'car-reviews-v2') {
      acc.push(link.slug.replace('car-reviews-v2/', ''))
    }

    return acc
  }, [])

  return [...new Set(makes)].flatMap((make) => ({ make }))
}

async function getTopModelForMake(make: string) {
  const links = await getLinks(`car-reviews-v2/${make.toLocaleLowerCase()}`)

  const models = Object.values(links)
    .filter((link) => link.slug !== 'car-reviews-v2')
    .filter((link) => link.is_folder)
    .filter((link) => link.slug.startsWith(`car-reviews-v2/${make}`))
    .map((link) => link.slug.replace(`car-reviews-v2/${make}`, ''))
    .map((slug) => slug.replace('/', '').trim())
    .filter((link) => link !== '')

  return [...new Set(models)].flatMap((model) => ({ make, model }))
}
